export default {
  TOGGLE_LOADING (state) {
    state.callingAPI = !state.callingAPI
  },
  TOGGLE_SEARCHING (state) {
    state.searching = (state.searching === '') ? 'loading' : ''
  },
  SET_MENU_START_TIME (state, menuStartTime) {
    state.menuStartTime = menuStartTime
  },
  SET_MENU_END_TIME (state, menuEndTime) {
    state.menuEndTime = menuEndTime
  },
  // user info
  SET_USER_ID (state, userId) {
    state.userId = userId
  },
  SET_TOKEN (state, token) {
    // alert('token')
    state.token = token
  },
  SET_AUTH_ERROR (state, authError) {
    state.authError = authError
  },
  SET_RESTRICT (state, RESTRICT) {
    state.restrictedList = RESTRICT
  },
  SET_NIDIN_LEAGUE (state, LEAGUE) {
    state.nidin_league = LEAGUE
  },
  SET_DENYLIST (state, denyList) {
    state.denyList = denyList
  },
  SET_TRADE_TPYE (state, value) {
    state.tradeType = value
  },
  SET_ROLE_TYPE (state, roleType) {
    state.roleType = roleType
  },
  SET_ACCOUNT (state, account) {
    state.account = account || ''
  },
  SET_UP_CATEGORY (state, upCategory) {
    state.upCategory = upCategory || false
  },
  SET_UP_ADJUST (state, upAdjust) {
    state.upAdjust = upAdjust || false
  },
  SET_MODAL (state, modal) {
    state.modal = modal || false
  },
  SET_SEL_MANAGER_ID (state, selManagerId) {
    state.selManagerId = selManagerId || 1
  },
  SET_SEL_ROLE_TYPE (state, selRoleType) {
    state.selRoleType = selRoleType || 'admin'
  },
  SET_MODAL_VIEW (state, modalView) {
    state.modalView = modalView || false
  },
  SET_BRAND_ID (state, brandId) {
    state.brandId = brandId || ''
  },
  SET_BRANDS (state, brands) {
    state.brands = brands
  },
  SET_STORE_ID (state, storeId) {
    state.storeId = storeId || ''
  },
  SET_STORE_INFO (state, stores) {
    state.storeInfo = stores
  },
  SET_STORES (state, stores) {
    state.stores = stores
  },
  SET_BLACK_REASON (state, blackReason) {
    state.blackReason = blackReason || []
  },
  SET_UNREAD_NOTIFY (state, amount) {
    state.unReadNotify = amount || 0
  },
  SET_CITY_LIST (state, list) {
    state.cityList = list || []
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js